module.exports = __webpack_public_path__ + "media/images/riders/small/HELEN_GROBERT-2358d4539c7ecfaf4c81c8e65efafbe1.png";